import { isDrop, isRise } from '../../constants/constants';
import { Card, DROP_SEVERITY_RANK } from '../../types/card';
import { needsHubRequest } from '../common/PriceHeld';

/** 가격 조회 표(DropReviewTable)의 네 탭 줄. */
export interface DropGroups {
  suspect: Card[];
  inRange: Card[];
  rise: Card[];
  noRef: Card[];
}

/**
 * 카드 목록 → 가격 조회 표의 네 탭(확인 필요 · 시세 범위 내 · 가격 상승 · 참조 없음). 표와 저장 필터 칩(건수)이 같은 묶음을
 * 쓰도록 한곳에 둔다(가격 목록 개편 PR 3, 감사 card-controltower#697) — 칩 건수가 표에 없는 카드를 세지 않게.
 */
export function groupDropCards(cards: Card[]): DropGroups {
  // dropBucket이 남아있어도 더 이상 하락이 아닌 카드(분류 후 반영/조정됨)는 제외한다 —
  // 백엔드가 다음 classify에서 정리하지만, 그 사이엔 isDrop으로 걸러 목록을 정합하게 유지.
  const drops = cards.filter((c) => isDrop(c.priceChangeStatus));
  const suspect = drops
    .filter((c) => c.dropBucket === 'SUSPECT')
    .sort((a, b) => {
      const r = DROP_SEVERITY_RANK[a.dropSeverity ?? 'MINOR'] - DROP_SEVERITY_RANK[b.dropSeverity ?? 'MINOR'];
      return r !== 0 ? r : Math.abs(b.priceChangeRate ?? 0) - Math.abs(a.priceChangeRate ?? 0);
    });
  const inRange = drops.filter((c) => c.dropBucket === 'IN_RANGE');
  const rise = cards
    .filter((c) => isRise(c.priceChangeStatus))
    .sort((a, b) => (b.priceChangeRate ?? 0) - (a.priceChangeRate ?? 0));
  const noRef = drops.filter((c) => c.dropBucket === 'NO_REFERENCE');
  // 보호 중(유지 · 적용가)인데 PriceHub 가격이 네이버 가격과 다른 카드(감사 #558 M2) — 보호로 하락이 아니게 되면 어느 목록에도 안 남아
  // PriceHub 에 요청할 길이 없었다. '확인 필요' 끝에 남겨 '매장 가격 요청' 을 누를 수 있게(재검토 대상은 아님 — 대기에 넣지 않는다).
  const held = cards.filter((c) => !isDrop(c.priceChangeStatus) && !isRise(c.priceChangeStatus) && needsHubRequest(c));
  return { suspect: [...suspect, ...held], inRange, rise, noRef };
}

/** 네 탭의 카드 전부(표 한 장의 '필터 전 전체'). */
export const allDropGroupCards = (g: DropGroups): Card[] => [...g.suspect, ...g.inRange, ...g.rise, ...g.noRef];
